"use client";

import { faSearch } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useSearchParams } from "next/navigation";
import { type ChangeEvent, useEffect, useState } from "react";
import { useDebounceValue } from "usehooks-ts";
import { useQuery } from "~/hooks/useQuery";
import { useRouter } from "~/hooks/useRouter";

interface Props {
	label: string;
}

export function Search({ label }: Props) {
	const searchParams = useSearchParams();
	const [query, setQuery] = useState<string>(searchParams.get("query") ?? "");
	const [debouncedQuery] = useDebounceValue(query, 500);
	const router = useRouter();
	const { createUrl } = useQuery();

	function onSearchChange(event: ChangeEvent<HTMLInputElement>) {
		setQuery(event.target.value);
	}

	// biome-ignore lint/correctness/useExhaustiveDependencies: router.replace is not a dependency
	useEffect(() => {
		router.replace(createUrl({ query: debouncedQuery }));
	}, [debouncedQuery, createUrl]);

	return (
		<div className="relative shrink-0 snap-start">
			<div className="pointer-events-none absolute inset-y-0 left-0 flex items-center pl-3">
				<FontAwesomeIcon icon={faSearch} className="h-4 w-4" />
			</div>

			<input
				type="search"
				value={query}
				onChange={onSearchChange}
				placeholder={`${label}...`}
				aria-label={label}
				className="h-full w-full rounded-full border border-shades pr-4 pl-9 transition-all focus:outline-none focus-visible:border-primary-dark focus-visible:ring-1 focus-visible:ring-primary-dark focus-visible:ring-inset"
			/>
		</div>
	);
}
